import API_BASE from "../apiConfig";
const API = `${API_BASE}/api/products`;

export const getProducts = async () => {
  const token = localStorage.getItem("token");
  const res = await fetch(API, {
    headers: { "auth-token": token }
  });
  return res.json();
};

export const addProduct = async (data) => {
  const token = localStorage.getItem("token");
  const res = await fetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json", "auth-token": token },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateProduct = async (id, data) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "auth-token": token },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteProduct = async (id) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API}/${id}`, {
    method: "DELETE",
    headers: { "auth-token": token },
  });
  return res.json();
};

export const adjustStock = async (id, data) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API}/${id}/adjust`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "auth-token": token },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const getStockHistory = async (id) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API}/${id}/history`, {
    headers: { "auth-token": token }
  });
  return res.json();
};